import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
// Import the AnimationProvider - ADD THIS LINE
import { AnimationProvider } from './context/animationContext';
// Import the AuthProvider
import { AuthProvider } from './context/authContext';
// Import the ProtectedRoute component
import ProtectedRoute from './components/protectedRoute';


import {
  Home,
  Portfolio,
  About,
  Contact,
  AdminDashboard,
  ProjectDetails
} from './pages';

function App() {
  return (
    // WRAP YOUR APP WITH AnimationProvider
    <AnimationProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/portfolio" element={<Portfolio />} />
              {/* Dynamic project route */}
              <Route path="/portfolio/:projectName" element={<ProjectDetails />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              {/* Optional: Add a catch-all route for 404 pages */}
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </AnimationProvider>
  );
}

export default App;